import axios from "axios";
import store from "./store";

// axios.defaults.baseURL = "https://najih-backend.developnetwork.net/api";
// axios.defaults.baseURL = "http://192.168.1.72:8000/api";
axios.defaults.baseURL = "https://market.developnetwork.net/api";

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;
    if (response && response.status === 401) {
      if (response.config.url.startsWith("/google-drive/")) {
        store.dispatch("googleDrive/setGoogleDriveError", true);
      }
    }
    return Promise.reject(error);
  }
);

export default axios;


